import React from 'react';

export const AttachmentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="50" viewBox="0 0 26 50" fill="none">
        <path
            d="M22.0909 11.3636V37.5C22.0909 42.5227 18.0227 46.5909 13 46.5909C7.97727 46.5909 3.90909 42.5227 3.90909 37.5V9.09091C3.90909 5.95455 6.45455 3.40909 9.59091 3.40909C12.7273 3.40909 15.2727 5.95455 15.2727 9.09091V32.9545C15.2727 34.2045 14.25 35.2273 13 35.2273C11.75 35.2273 10.7273 34.2045 10.7273 32.9545V11.3636H7.31818V32.9545C7.31818 36.0909 9.86364 38.6364 13 38.6364C16.1364 38.6364 18.6818 36.0909 18.6818 32.9545V9.09091C18.6818 4.06818 14.6136 0 9.59091 0C4.56818 0 0.5 4.06818 0.5 9.09091V37.5C0.5 44.4091 6.09091 50 13 50C19.9091 50 25.5 44.4091 25.5 37.5V11.3636H22.0909Z"
            fill="#2281CC"
        />
    </svg>
);
